function checkUpsell() {
  let upsellChecked = document.querySelectorAll(".lb-spc-details-checkbox:checked");
  let upsellData = [];

 for (let i = 0; i < upsellChecked.length; i++) {
  const checkbox = upsellChecked[i];
  const cardElement = checkbox.closest(".lb-upsell-product-page-card");

  const selectElement = cardElement.querySelector(
    ".lb-shared-variants-select.border-animation"
  );
  const selectedIndex = selectElement.selectedIndex;
  const selectedOption = selectElement.options[selectedIndex].value;

  let variantData;
  try {
    variantData = JSON.parse(selectedOption);
  } catch (e) {
    console.error("Invalid JSON in select option:", selectedOption);
    continue;
  }

  const priceElement = cardElement.querySelector(".lb-upsell-money-2.money.bacurr-money");

  let priceHtml = "";
  if (priceElement) {
    const text = priceElement.textContent.trim();

    // If the price text does not already start with a currency symbol/letters
    if (!/^[a-zA-Z₹$€£]/.test(text)) {
      priceElement.textContent = "RM " + text;
    }

    priceHtml = priceElement.outerHTML;
  }

  upsellData.push({
    ...variantData,
    priceHtml
  });
}


  console.log("upsellData", JSON.stringify(upsellData));
  localStorage.setItem("upsellData", JSON.stringify(upsellData));
}

const observerUpsell = new MutationObserver(
  (mutationsList, observerInstance) => {
    if (document.querySelectorAll(".lb-spc-details-checkbox").length) {
      document
        .querySelectorAll(".lb-spc-details-checkbox")
        .forEach((checkbox) => {
          checkbox.addEventListener("change", checkUpsell);
        });

      document
        .querySelectorAll(".lb-shared-variants-select.border-animation")
        .forEach((select) => {
          select.addEventListener("change", checkUpsell);
        });
      // observerInstance.disconnect();
    }
  }
);

observerUpsell.observe(document.body, { childList: true, subtree: true });
if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();

      this.setImageSet();

      // Code by Ruby - Convx - TL-3562 - filter images by variant on initial load
      if (this.currentVariant) {
        this.filterImagesByColor();
      }
      // End of TL-3562
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;

      // Code by Ruby - Convx - TL-3562 - Filter images based on selected variant first
      this.filterImagesByColor();
      // End of TL-3562

      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);

      // Code by Ruby - Convx - TL-3562 - If the image is hidden after filter, find the first visible image
      if (!activeMedia || activeMedia.classList.contains('color-filtered-hidden')) {
        const visibleImages = Array.from(this.productSlider.querySelectorAll('[data-image-alt]')).filter(
          slide => !slide.classList.contains('color-filtered-hidden')
        );
        if (visibleImages.length > 0) {
          activeMedia = visibleImages[0];
        }
      }
      // End of TL-3562

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      // Code by Ruby - Convx - TL-3562
      // activeMedia.classList.add('is-active');

      // activeMedia.parentElement.prepend(activeMedia);

      // window.setTimeout(() => {
      //   activeMedia.parentElement.scrollTo({
      //     left: 0,
      //     top: 0,
      //     behavior: 'smooth'
      //   });
      // });
      if (activeMedia) {
        activeMedia.classList.add('is-active');
        activeMedia.parentElement.prepend(activeMedia);

        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth'
          });
        });
      }
      // End of TL-3562
    }

    // Code by Ruby - Convx - TL-3562
    getColorOption() {
      if (!this.currentVariant || !this.currentVariant.options) return null;
      
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      let colorOptionIndex = null;
      let colorValue = null;
      
      fieldsets.forEach((fieldset, index) => {
        const label = fieldset.querySelector('.form__label');
        if (label) {
          const labelText = label.textContent.toLowerCase();
          if (labelText.includes('color') || labelText.includes('colour') || labelText.includes('design')) {
            colorOptionIndex = index;
            const selectedInput = fieldset.querySelector('input:checked, select');
            if (selectedInput) {
              colorValue = selectedInput.value;
            } else {
              // Fallback to variant option
              colorValue = this.currentVariant.options[index];
            }
          }
        }
      });
      
      if (colorOptionIndex === null) {
        return null;
      }
      
      // if we found a color fieldset but no value, try variant option
      if (colorOptionIndex !== null && !colorValue && this.currentVariant.options[colorOptionIndex]) {
        colorValue = this.currentVariant.options[colorOptionIndex];
      }
      
      return colorValue ? colorValue.toLowerCase().trim() : null;
    }

    getAllColorOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      let colorOptionIndex = null;
      
      fieldsets.forEach((fieldset, index) => {
        const label = fieldset.querySelector('.form__label');
        if (label) {
          const labelText = label.textContent.toLowerCase();
          if (labelText.includes('color') || labelText.includes('colour') || labelText.includes('design')) {
            colorOptionIndex = index;
          }
        }
      });
      
      if (colorOptionIndex === null) {
        return [];
      }
      
      const variantData = this.getVariantData();
      const colorOptions = new Set();
      
      variantData.forEach(variant => {
        if (variant.options && variant.options[colorOptionIndex]) {
          const normalized = variant.options[colorOptionIndex].toLowerCase().trim().replace(/\s+/g, '_');
          colorOptions.add(normalized);
        }
      });
      
      return Array.from(colorOptions);
    }

    filterImagesByColor() {
      if (!this.productSlider) return;
      
      // Get all image slides that with and without data-image-alt attribute
      const allImageSlides = this.productSlider.querySelectorAll('.product-images__slide--image');
      
      const slidesWithAltAttr = this.productSlider.querySelectorAll('[data-image-alt]');
      const imagesWithAlt = Array.from(slidesWithAltAttr).filter(slide => {
        const alt = slide.getAttribute('data-image-alt');
        return alt && alt.trim() !== '';
      });
      
      // If images no alt text, show all images
      if (imagesWithAlt.length === 0) {
        allImageSlides.forEach((slide) => {
          slide.classList.remove('color-filtered-hidden');
        });
        return;
      }
      
      const selectedColor = this.getColorOption();
      if (!selectedColor) {
        // If no variant selected, show all images
        allImageSlides.forEach((slide) => {
          slide.classList.remove('color-filtered-hidden');
        });
        return;
      }
      
      const normalizedVariant = selectedColor.replace(/\s+/g, '_').toLowerCase().trim();
      
      const allColorOptions = this.getAllColorOptions();
      
      // Check image alt text contains variant information, If no alt text matches show all images
      let hasVariantSpecificAlt = false;
      imagesWithAlt.forEach((slide) => {
        const alt = slide.getAttribute('data-image-alt');
        if (alt && alt.trim() !== '') {
          const normalizedAlt = alt.toLowerCase().trim().replace(/\s+/g, '_');
          
          // Check for exact match
          if (normalizedAlt === normalizedVariant) {
            hasVariantSpecificAlt = true;
            return;
          }
          
          // If the alt text exactly matches any variant name, only match that exact variant
          const isExactVariantName = allColorOptions.some(option => option === normalizedAlt);
          
          if (isExactVariantName) {
            return;
          }
          
          // For combined variants, check if the normalized variant appears as a complete token
          const variantRegex = new RegExp(`(^|[_\\s,]+)${normalizedVariant.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([_\\s,]+|$)`, 'i');
          if (variantRegex.test(normalizedAlt)) {
            hasVariantSpecificAlt = true;
          }
        }
      });
      
      if (!hasVariantSpecificAlt) {
        allImageSlides.forEach((slide) => {
          slide.classList.remove('color-filtered-hidden');
        });
        return;
      }
      
      allImageSlides.forEach((slide) => {
        const imageAlt = slide.getAttribute('data-image-alt');
        
        if (!imageAlt || imageAlt.trim() === '') {
          slide.classList.remove('color-filtered-hidden');
          return;
        }
        
        const normalizedAlt = imageAlt.toLowerCase().trim().replace(/\s+/g, '_');
        
        // Check for exact match first
        if (normalizedAlt === normalizedVariant) {
          slide.classList.remove('color-filtered-hidden');
          return;
        }
        
        // If the alt text exactly matches any variant name, only match that exact variant
        // To prevents example "merah" from matching "merah_jambu" when "merah_jambu" is a variant name
        const isExactVariantName = allColorOptions.some(option => option === normalizedAlt);
        
        if (isExactVariantName) {
          // Alt text is an exact variant name, so only match if it's the selected variant
          slide.classList.add('color-filtered-hidden');
          return;
        }
        
        // For combined variants, check if the normalized variant appears as a complete token
        // This handles cases like:
        // - "ayu_black" matching in "ayu_black_ayu_green" (compound variant names)
        // - "white" matching in "white_green" (simple variant names)
        // We use word boundaries to ensure we match complete tokens, not substrings
        // For underscore-separated text, we need to check if the variant appears as a complete segment
        const variantRegex = new RegExp(`(^|[_\\s,]+)${normalizedVariant.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([_\\s,]+|$)`, 'i');
        const variantMatches = variantRegex.test(normalizedAlt);
        
        if (variantMatches) {
          slide.classList.remove('color-filtered-hidden');
        } else {
          slide.classList.add('color-filtered-hidden');
        }
      });
    }
    // End of TL-3562

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        var notifyMeButton = document.getElementById('dd-notify-me-button');
        
        if (!submitButtonText) return;

        if (disable) {
          if (notifyMeButton) notifyMeButton.setAttribute('style', 'display:inline !important;');
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
          if (notifyMeButton) notifyMeButton.setAttribute('style', 'display:none !important;');
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              // Previously target input then input[id*="main-product"]. However, targeting may not be specific. Temporary test to see if problem persist input[name="Size"]
              fieldset.querySelectorAll('.option-disabler').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }
           const items = Array.isArray(response.items)
              ? response.items
              : [response];

            // Show main product
            const primaryItem = items[0];
            let isShowCustomPopup = false
            let showCustomPopup = document.querySelector('#show-custom-popup').textContent
            // console.log("heyy")

            /* Code by Ruby - Convx - TL-3172 */
            let showATCConfirmationBarPopUp = document.querySelector('#show-atc-confirmation-bar-popup').textContent

            if(showCustomPopup == 'true' && showATCConfirmationBarPopUp == 'false'){
              this.showConfirmationPopup(primaryItem, response);
            }

            if(showATCConfirmationBarPopUp == 'true' && showCustomPopup == 'false'){
              const productDrawer = document.getElementById('Product-Drawer');
              
              if (productDrawer && productDrawer.classList.contains('active')) {
                this.closeProductDrawer(() => {
                  this.showATCConfirmationBarPopUp();
                });
              } else {
                this.showATCConfirmationBarPopUp();
              }
            }
            /* End of TL-3172 */

            // Code by Ruby - Convx - TL-3657
            this.updateCartItemCount(response);
            // Uncomment the renderContents function to update the cart drawer contents.
            this.renderContents(response);
            // End of TL-3657

            // Dispatch event for each main product item
            items.forEach((item, index) => {
              dispatchCustomEvent("cart:item-added", {
                product: item,
                itemIndex: index,
                totalItems: items.length,
              });
            });

            // Wait for upsell additions to complete, then update the popup
            setTimeout(() => {
              this.appendUpsellItemsToPopup();
            }, 1000); // Adjust delay based on when upsells are added

            console.log("=== FORM SUBMISSION END ===");
          
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }
          // === Confirmation Popup Logic ===

showConfirmationPopup(primaryItem, fullResponse) {
        console.log("=== SHOWING CONFIRMATION POPUP ===");
        let productTitle = primaryItem.product_title;
        let productImage = primaryItem.featured_image.url;
        let variantTitle = primaryItem.variant_title;
        let quantity = primaryItem.quantity || 1;
        // let variantPrice = document.querySelector(
        //   ".product-price-container .money"
        // )?.innerHTML;

        // Get price elements from the product form - #2920
        let priceContainer = document.querySelector(".price ins .money");
        if (priceContainer) {
          // Copy the entire price HTML which includes both original and discounted prices
          document.getElementById("popup-product-price").innerHTML = priceContainer.outerHTML;
        }

        document.getElementById("popup-product-title").textContent =
          productTitle;
        document.getElementById("popup-product-image").src = productImage;
        // document.getElementById("popup-product-price").textContent =
        //   variantPrice;
        document.getElementById("popup-product-size").textContent =
          variantTitle;
        document.getElementById("Quantity-confirmation-popup").value = quantity;

        this.setupPopupFunctionality(primaryItem, fullResponse);

        document.getElementById("slideup-popup").classList.add("active");
        document.getElementById("overlay").classList.add("show");
        document.body.style.overflow = "hidden";

        setTimeout(function () {
          $(".upsell-product-container").flickity({
            cellAlign: "left",
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            percentPosition: false,
            freeScroll: true,
          });
        }, 500);
        
        // Setup quantity controls for MAIN PRODUCT ONLY
        this.setupMainProductQuantityControls(primaryItem);
      }

      setupPopupFunctionality(primaryItem, fullResponse) {
        console.log(fullResponse,"fullResponsefullResponse")
        if (
  (Array.isArray(fullResponse.items) && fullResponse.items.length === 0) ||
  !document.querySelector('.popup-product-info')
) {
  window.location.reload();
}

        const getFreeShipping = (lineItemKey, totalQty) => {
          console.log("getFreeShipping called with:", lineItemKey, totalQty);

          fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              $("#free-shipping-price").load(
                location.href + " #free-shipping-price"
              );

              let freeShippingThreshold = document
                .getElementById("free-shipping-price")
                .getAttribute("data-shipping-price");
              const currentTotal = cart.total_price / 100;
              const message = document.getElementById("free-shipping-message");
              const barFill = document.getElementById("free-shipping-bar-fill");

              if (currentTotal >= freeShippingThreshold) {
                message.innerHTML = "FREE shipping will be applied at checkout";
                barFill.style.width = "100%";
                barFill.style.backgroundColor = "#4caf50";
              } else {
                 const remaining = (freeShippingThreshold - currentTotal).toFixed(2);
       message.innerHTML = `You're <span id="free-shipping-price" class="money bacurr-money">${remaining}</span> away from Free Shipping!`;

const freeShippingEl = document.querySelector("#free-shipping-message #free-shipping-price");

// Only prepend "RM" if the element doesn't already contain any letters (i.e., currency)
if (freeShippingEl && !/[a-zA-Z]/.test(freeShippingEl.textContent)) {
  freeShippingEl.textContent = "RM" + freeShippingEl.textContent;
}

          const progress = (currentTotal / freeShippingThreshold) * 100;
          barFill.style.width = `${progress}%`;
          barFill.style.backgroundColor = "#BF9000";
              }
            })
            .catch((error) => {
              console.error("Error fetching cart:", error);
            });
        };

        getFreeShipping(primaryItem.key, primaryItem.quantity);
      }

      // === MAIN PRODUCT QUANTITY CONTROLS ===
      setupMainProductQuantityControls(primaryItem) {
  console.log("Setting up MAIN product quantity controls for:", primaryItem);

  const qtyInput = document.getElementById("Quantity-confirmation-popup");
  const plusBtn = document.querySelector(".popup-qty-container .plus");
  const minusBtn = document.querySelector(".popup-qty-container .minus");
  const deleteBtn = document.querySelector(".popup-qty-container .removeItem"); 

  if (!qtyInput || !plusBtn || !minusBtn) {
    console.warn("Main product quantity buttons or input not found.");
    return;
  }

  // Remove existing event listeners to prevent duplicates
  const newPlusBtn = plusBtn.cloneNode(true);
  const newMinusBtn = minusBtn.cloneNode(true);
  plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
  minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);

  const updateMainProductQuantity = (newQty) => {
    console.log("Updating MAIN product cart quantity to:", newQty);

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: primaryItem.key,
        quantity: newQty,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((cart) => {
        console.log("Main product cart updated:", cart);

        const updatedItem = cart.items.find(item => item.key === primaryItem.key);
        qtyInput.value = updatedItem ? updatedItem.quantity : newQty;

        const errorElement = document.querySelector(".popup-error-message");
        if (errorElement) errorElement.textContent = "";

        this.setupPopupFunctionality(primaryItem, cart);
      })
      .catch((err) => {
        console.error("Error updating main product cart:", err);
        const errorBox = document.querySelector(".popup-error-message");
        if (errorBox) {
          errorBox.textContent =
            err?.description ||
            "An error occurred while updating the cart.";
        }
      });
  };

  const deleteMainProduct = ((e) =>{
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: primaryItem.key,
        quantity: 0,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((cart) => {
        console.log("Main product deleted from cart:", cart);

        // You might want to hide or reset the popup here
        e.target.closest(".popup-product-info").remove()
        
        this.setupPopupFunctionality(primaryItem, cart);
      })
      .catch((err) => {
        console.error("Error deleting main product from cart:", err);
        const errorBox = document.querySelector(".popup-error-message");
        if (errorBox) {
          errorBox.textContent =
            err?.description ||
            "An error occurred while deleting the product.";
        }
      });
  });

  // Plus button
  newPlusBtn.addEventListener("click", () => {
    console.log("Main product plus button clicked, current value:", qtyInput.value);
    let currentQty = parseInt(qtyInput.value, 10);
    if (isNaN(currentQty)) currentQty = 1;
    const newQty = currentQty + 1;
    updateMainProductQuantity(newQty);
  });

  // Minus button
  newMinusBtn.addEventListener("click", () => {
    console.log("Main product minus button clicked, current value:", qtyInput.value);
    let currentQty = parseInt(qtyInput.value, 10);
    if (isNaN(currentQty)) currentQty = 1;
    if (currentQty <= 1) return;
    const newQty = currentQty - 1;
    updateMainProductQuantity(newQty);
  });

  // Delete button
  if (deleteBtn) {
    deleteBtn.addEventListener("click", (e) => {
      console.log("Delete button clicked for main product.");
      deleteMainProduct(e);
    });
  }
}


      // === UPSELL PRODUCT QUANTITY CONTROLS ===
      setupUpsellQuantityControls(upsellItem, productContainer) {
  console.log("Setting up UPSELL quantity controls for:", upsellItem.product_title);

  const qtyInput = productContainer.querySelector(".qty");
  const plusBtn = productContainer.querySelector(".plus");
  const minusBtn = productContainer.querySelector(".minus");
  const deleteBtn = productContainer.querySelector(".delete-upsell");

  if (!qtyInput || !plusBtn || !minusBtn) {
    console.warn("Upsell quantity buttons or input not found for product:", upsellItem.product_title);
    return;
  }

  const updateUpsellQuantity = (newQty) => {
    console.log("Updating UPSELL product cart quantity to:", newQty, "for product:", upsellItem.product_title);

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: upsellItem.key,
        quantity: newQty,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((cart) => {
        console.log("Upsell product cart updated:", cart);

        const updatedItem = cart.items.find(item => item.key === upsellItem.key);
        if (updatedItem) {
          qtyInput.value = updatedItem.quantity;
        } else {
          qtyInput.value = newQty;
        }

        const errorElement = productContainer.querySelector(".popup-error-message");
        if (errorElement) {
          errorElement.textContent = "";
        }

        this.setupPopupFunctionality(upsellItem, cart);
      })
      .catch((err) => {
        console.error("Error updating upsell product cart:", err);

        const errorBox = productContainer.querySelector(".popup-error-message");
        if (errorBox) {
          errorBox.textContent =
            err?.description ||
            "An error occurred while updating the cart.";
        }
      });
  };

  const deleteUpsellProduct = () => {
    console.log("Deleting upsell product:", upsellItem.product_title);

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: upsellItem.key,
        quantity: 0,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((cart) => {
        console.log("Upsell product deleted from cart:", cart);

        productContainer.remove();
        this.setupPopupFunctionality(upsellItem, cart);
      })
      .catch((err) => {
        console.error("Error deleting upsell product from cart:", err);

        const errorBox = productContainer.querySelector(".popup-error-message");
        if (errorBox) {
          errorBox.textContent =
            err?.description ||
            "An error occurred while deleting the product.";
        }
      });
  };

  // ✅ Plus button - Fetch latest quantity from cart before increasing
  plusBtn.addEventListener("click", () => {
    console.log("Upsell product plus button clicked for:", upsellItem.product_title, "current value:", qtyInput.value);

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const currentCartItem = cart.items.find(item => item.key === upsellItem.key);
        let currentQty = currentCartItem ? currentCartItem.quantity : parseInt(qtyInput.value, 10) || 1;
        const newQty = currentQty + 1;
        updateUpsellQuantity(newQty);
      })
      .catch((err) => {
        console.error("Failed to fetch cart before increasing quantity:", err);
      });
  });

  // ✅ Minus button
  minusBtn.addEventListener("click", () => {
    console.log("Upsell product minus button clicked for:", upsellItem.product_title, "current value:", qtyInput.value);

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const currentCartItem = cart.items.find(item => item.key === upsellItem.key);
        let currentQty = currentCartItem ? currentCartItem.quantity : parseInt(qtyInput.value, 10) || 1;

        if (currentQty <= 1) return;
        const newQty = currentQty - 1;
        updateUpsellQuantity(newQty);
      })
      .catch((err) => {
        console.error("Failed to fetch cart before decreasing quantity:", err);
      });
  });

  // Delete button
  if (deleteBtn) {
    deleteBtn.addEventListener("click", () => {
      console.log("Delete button clicked for upsell product:", upsellItem.product_title);
      deleteUpsellProduct();
    });
  }
}


      // === Upsell Handling ===
      appendUpsellToPopupContent(upsell) {
        const popupContent = document.querySelector(".popup-content");
        if (!popupContent) return;

        const productHTML = `
    <div class="popup-product-info upsell-product" data-key="${upsell.key}">
      <img class="upsell-product-image" src="${upsell.featured_image.url}" alt="${
          upsell.product_title
        }">
      <div class="upsell-product-details">
        <div class="upsell-product-header">
          <div class="upsell-product-title">${upsell.product_title}</div>
        </div>
         <div id="popup-product-price">
         <div class="upsell-price">${upsell.priceHtml || ''}</div>
        </div>
        <div><span class="upsell-product-size">${upsell.variant_title}</span></div>
        <div class="popup-qty-container upsell-qty-container">
          <quantity-selector class="quantity buttons_added">
            <button class="minus" type="button">−</button>
            <input type="number" class="qty" value="${
              upsell.quantity || 1
            }" min="1" step="1" disabled>
            <button class="plus" type="button">+</button>
          </quantity-selector>
          <button class="delete-upsell">
<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3L1 3M5.00024 6V10M8.00024 6V10M11.0002 3V12.5C11.0002 12.6326 10.9476 12.7598 10.8538 12.8536C10.76 12.9473 10.6329 13 10.5002 13H2.50024C2.36764 13 2.24046 12.9473 2.14669 12.8536C2.05292 12.7598 2.00024 12.6326 2.00024 12.5V3M9.00025 3V2C9.00025 1.73478 8.89489 1.48043 8.70735 1.29289C8.51982 1.10536 8.26546 1 8.00024 1H5.00024C4.73503 1 4.48067 1.10536 4.29314 1.29289C4.1056 1.48043 4.00024 1.73478 4.00024 2V3" stroke="#E93636" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>
</button>
        </div>
      </div>
    </div>
  `;

        popupContent.insertAdjacentHTML("beforeend", productHTML);
        
        // Return the newly created element so we can set up its controls
        return popupContent.lastElementChild;
      }

     appendUpsellItemsToPopup() {
  let hasProcessed = false;
  let selectedUpsellVariants = [];

  const processUpsellItems = () => {
    if (hasProcessed) return;
    hasProcessed = true;

    const selectedValue = JSON.parse(localStorage.getItem("upsellData"));

    try {
      if (selectedValue && Array.isArray(selectedValue)) {
        selectedUpsellVariants = selectedValue
          .filter((i) => i?.id)
          .map((i) => ({
            id: i.id,
            priceHtml: i.priceHtml || '', // read directly from localStorage
          }));
      }
    } catch (e) {
      console.error("Error parsing upsellData:", selectedValue);
    }
  };

  if (document.querySelectorAll(".lb-spc-details-checkbox").length) {
    processUpsellItems();
  }

  if (!selectedUpsellVariants.length) {
    console.log("No checked upsell variants.");
    return;
  }

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const matchingItems = cart.items.filter((item) =>
        selectedUpsellVariants.some((v) => v.id === item.id)
      );

      if (!matchingItems.length) {
        console.log("No matching upsell items found in cart.");
        return;
      }

      matchingItems.forEach((item) => {
        const upsellVariant = selectedUpsellVariants.find((v) => v.id === item.id);

        const itemWithPrice = {
          ...item,
          priceHtml: upsellVariant?.priceHtml || ''
        };

        const productContainer = this.appendUpsellToPopupContent(itemWithPrice);

        if (productContainer) {
          this.setupUpsellQuantityControls(itemWithPrice, productContainer);
        }
      });
    })
    .catch((err) => {
      console.error("Error fetching cart:", err);
    });
}


    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      // Code by Ruby - Convx - TL-3657 For AB testing (A = cart page, B = cart drawer), default to 'A' for live version
      const abVariant = window.cartABTestVariant || 
                        (document.body ? document.body.getAttribute('data-cart-ab-variant') : null) || 
                        'A';
      // End of TL-3657

      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        // Code by Ruby - Convx - TL-3657
        if (abVariant === 'A') {
          product_drawer.classList.remove('active');
          window.location.href = theme.routes.cart_url;
          return;
        }
        // End of TL-3657

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        // Code by Ruby - Convx - TL-3657
        if (abVariant === 'A') {
          window.location.href = theme.routes.cart_url;
          return;
        }
        // End of TL-3657
        
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    // Code by Ruby - Convx - TL-3657
    updateCartItemCount(response) {
      fetch('/cart.js')
        .then(cartResponse => cartResponse.json())
        .then(cart => {
          const itemCount = cart.item_count || 0;
          this.updateItemCountElements(itemCount);
        })
        .catch(e => {
          console.error('Error fetching cart for item count:', e);
          let itemCount = 0;
          if (response.item_count !== undefined) {
            itemCount = response.item_count;
          } else if (response.items && Array.isArray(response.items)) {
            itemCount = response.items.reduce((total, item) => total + (item.quantity || 1), 0);
          }
          if (itemCount > 0) {
            this.updateItemCountElements(itemCount);
          }
        });
    }
    updateItemCountElements(itemCount) {
      const itemCountElements = document.querySelectorAll('.thb-item-count');
      itemCountElements.forEach(element => {
        if (itemCount > 99) {
          if (!element.querySelector('svg')) {
            element.textContent = '99+';
          }
        } else {
          element.textContent = itemCount;
        }
      });
    }
    // End of TL-3657

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    /* Code by Ruby - Convx - TL-3172 */
    showATCConfirmationBarPopUp() {
      const productAtcConfirmation = document.querySelector('#product-atc-confirmation-bar');
      if (productAtcConfirmation) {

        // Code by Ruby - Convx - TL-3824
        const freeShippingThresholdAttr = productAtcConfirmation.getAttribute('data-free-shipping-threshold');
        const progressMessageAttr = productAtcConfirmation.getAttribute('data-free-shipping-progress-message');
        const successMessageAttr = productAtcConfirmation.getAttribute('data-free-shipping-success-message');
        const parsedThreshold = parseFloat(freeShippingThresholdAttr);
        const isThresholdInvalid = !freeShippingThresholdAttr || 
                                  freeShippingThresholdAttr.trim() === '' || 
                                  isNaN(parsedThreshold) || 
                                  parsedThreshold <= 0;
        
        const isAnySettingBlank = isThresholdInvalid || 
                                  !progressMessageAttr || progressMessageAttr.trim() === '' || 
                                  !successMessageAttr || successMessageAttr.trim() === '';
        
        if (isAnySettingBlank) {
          const progressBarTextRows = document.querySelectorAll('.progress-bar-text-row');
          if(progressBarTextRows.length > 0){
            progressBarTextRows.forEach(row => {
              row.style.display = 'none';
            });
          }

          const content = document.querySelector('.product-atc-confirmation-content');
          if(content){
            content.style.alignItems = 'center';
          }
          
          const cartCol = document.querySelector('.product-atc-confirmation-cart-col');
          if (cartCol) {
            cartCol.style.paddingTop = '0';
          }
        }
        
        const freeShippingThreshold = parseFloat(freeShippingThresholdAttr);
        const progressMessage = progressMessageAttr;
        const successMessage = successMessageAttr;
        
        fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const cartTotal = cart.total_price / 100;
          const freeShippingText = document.getElementById('product-atc-free-shipping-text');
          const progressBarFill = document.getElementById('product-atc-progress-bar-fill');
          
          if (freeShippingText) {
            if (cartTotal >= freeShippingThreshold) {
              freeShippingText.innerHTML = successMessage;
              if (progressBarFill) {
                progressBarFill.style.width = '100%';
              }
            } else {
              const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
              const message = progressMessage.replace(/RMXX/g, `RM${remaining}`);
              freeShippingText.innerHTML = message;
              
              if (progressBarFill) {
                const progressPercentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
                progressBarFill.style.width = `${progressPercentage}%`;
              }
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching cart:', error);
          const freeShippingText = document.getElementById('product-atc-free-shipping-text');
          const progressBarFill = document.getElementById('product-atc-progress-bar-fill');
          if (freeShippingText) {
            freeShippingText.innerHTML = progressMessage.replace(/RMXX/g, 'RM0.00');
          }
          if (progressBarFill) {
            progressBarFill.style.width = '0%';
          }
        });
        // End of TL-3824

        productAtcConfirmation.classList.remove('hide');
        productAtcConfirmation.classList.add('show');
        
        this.setupCloseButtonListener();
        
        setTimeout(() => {
          productAtcConfirmation.classList.remove('show');
          productAtcConfirmation.classList.add('hide');
          
          setTimeout(() => {
            productAtcConfirmation.classList.remove('hide');
          }, 400);
        }, 5000);
      }
    }

    setupCloseButtonListener() {
      if (this.closeButtonListenerSetup) return;
      
      const productAtcConfirmationCloseBTN = document.querySelector('#product-atc-confirmation-bar .product-atc-confirmation-close-icon');
      
      if (productAtcConfirmationCloseBTN) {
        productAtcConfirmationCloseBTN.addEventListener('click', () => {
          const productAtcConfirmation = document.querySelector('#product-atc-confirmation-bar');
          
          if (productAtcConfirmation) {
            productAtcConfirmation.classList.remove('show');
            productAtcConfirmation.classList.add('hide');
            
            setTimeout(() => {
              productAtcConfirmation.classList.remove('hide');
            }, 400);
          }
        });
        
        this.closeButtonListenerSetup = true;
      }
    }

    closeProductDrawer(callback) {
      const productDrawer = document.getElementById('Product-Drawer');
      if (!productDrawer) {
        if (callback) callback();
        return;
      }

      productDrawer.classList.remove('active');
      document.body.classList.remove('open-quick-view');
      
      if (!document.getElementById('Cart-Drawer') || !document.getElementById('Cart-Drawer').classList.contains('active')) {
        document.body.classList.remove('open-cc');
      }

      const quickImagesContainer = productDrawer.querySelector('.product-quick-images--container');
      let callbackCalled = false;
      
      const executeCallback = () => {
        if (!callbackCalled) {
          callbackCalled = true;
          if (callback) callback();
        }
      };

      if (quickImagesContainer) {
        quickImagesContainer.classList.remove('active');
        
        const transitionHandler = () => {
          quickImagesContainer.removeEventListener('transitionend', transitionHandler);
          executeCallback();
        };
        
        quickImagesContainer.addEventListener('transitionend', transitionHandler);
        
        setTimeout(() => {
          executeCallback();
        }, 500);
      } else {
        executeCallback();
      }
    }
    /* End of TL-3172 */
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}